const contactlessRoute = {
  MAIN_CONTACTLESS: '/tokoonline',
  CONTACTLESS_DINING: '/tokoonline/dining',
  CONTACTLESS_ONLINE_ORDER: '/tokoonline/online-order',
}

export default contactlessRoute
